<template>
  <section class="form">
    <b-tabs type="is-toggle-rounded" class="px-2">
      <b-tab-item label="Add Schools To Existing Project">
        <add-schools></add-schools>
      </b-tab-item>
      <b-tab-item label="Edit Grades And Classes">
        <edit-schools></edit-schools>
      </b-tab-item>
    </b-tabs>
  </section>
</template>

<script>
import Vue from "vue";
import mapValues from "lodash/mapValues";
import { mapState, mapActions } from "vuex";
import AddSchools from "@/components/AddSchoolsComponents";
import EditSchools from "@/components/EditSchoolsComponents";

export default {
  name: "schools-project",
  components: {
    "add-schools": AddSchools,
    "edit-schools": EditSchools
  }
};
</script>
